var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "movimientos",
              attrs: {
                deleteButton: _vm.puede_anular,
                createButton: _vm.puede_registrar,
                editButton: false,
                path: _vm.path,
                columns: [
                  {
                    display: "Fecha",
                    value: "fecha"
                  },
                  {
                    display: "Valor",
                    value: "valor",
                    numeric: true
                  },
                  {
                    display: "Sucursal",
                    value: "bodega.descripcion"
                  },
                  {
                    display: "Oficinista",
                    value: "oficinista.nombre"
                  },
                  {
                    display: "Persona",
                    value: "persona.nombre"
                  },
                  {
                    display: "Vendedor",
                    value: "vendedor.descripcion"
                  },
                  {
                    display: "Detalle",
                    value: "detalle"
                  },
                  {
                    display: "Tipo de movimiento",
                    value: "tipo_movimiento.descripcion"
                  },
                  {
                    display: "Creación",
                    value: "created_at"
                  }
                ]
              },
              on: { crear: _vm.crear, eliminar: _vm.eliminar }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "movimiento",
            scrollable: "",
            resizable: "",
            reset: "",
            adaptive: "",
            height: "auto",
            width: "60%"
          }
        },
        [
          _c("movimiento", {
            ref: "movimiento",
            attrs: {
              bodegas: _vm.bodegas,
              tiposMovimiento: _vm.tiposMovimiento
            },
            on: { cancelar: _vm.cancelar, saved: _vm.savedMovimiento },
            model: {
              value: _vm.selectedMovimiento,
              callback: function($$v) {
                _vm.selectedMovimiento = $$v
              },
              expression: "selectedMovimiento"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Movimientos de Nómina")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63cf675a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63cf675a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ListaMovimientos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-63cf675a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ListaMovimientos.vue
// module chunks = 0